import { YesNo } from '@zorro/types';

export const convertToYesNoEnum = (value: boolean) => {
  return value ? YesNo.YES : YesNo.NO;
};

export const convertToMaybeYesNoEnum = (
  value: boolean | null | undefined
): YesNo | null | undefined => {
  if (value === null || value === undefined) {
    return value;
  }
  return convertToYesNoEnum(value);
};

export const convertToYesNo = (value: boolean): string => {
  return value ? 'Yes' : 'No';
};

export const convertToMaybeYesNo = (
  value: boolean | null | undefined
): string | null | undefined => {
  if (value === null || value === undefined) {
    return value;
  }
  return convertToYesNo(value);
};

export const convertFromYesNo = (value?: YesNo): boolean => {
  return value === YesNo.YES;
};

export const convertEnumToYesNo = (value: YesNo): string => {
  return convertToYesNo(convertFromYesNo(value));
};

export const convertFromMaybeYesNo = (
  value: YesNo | null | undefined
): boolean | null | undefined => {
  if (value === null || value === undefined) {
    return value;
  }
  return convertFromYesNo(value);
};
